export const PassportOrganizationId = -1;
